import { Descriptions, Modal, Timeline, Tooltip } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const StateToTextMap = {
	interested: 'Interested',
	toInterview: 'To Interview',
	offer: 'Offer',
	hired: 'Hired',
	rejected: 'Rejected'
};

export default function ApplicationStateChangeLogViewModal({ application, visible = false, onCancel }) {
	return (
		<Modal title={'State Change Log'} visible={visible} footer={null} onCancel={onCancel}>
			<div className="counter-offers">
				<Timeline mode="left">
					<Timeline.Item>
						<div className="d-flex justify-content-between">
							<Tooltip title={dayjs(application.createdAt).format('ddd, MMM D, YYYY h:mm A')}>
								<b>Applied </b>
								{dayjs(application.assignedAt).format('ddd, MMM D, YYYY h:mm A')}
							</Tooltip>
						</div>
					</Timeline.Item>
					{application.stateChangeLog.map((log, indx) => (
						<Timeline.Item>
							<div className="d-flex justify-content-between">
								<Tooltip title={dayjs(log.createdAt).format('ddd, MMM D, YYYY h:mm A')}>
									{dayjs(log.createdAt).format('ddd, MMM D, YYYY h:mm A')}
								</Tooltip>
							</div>
							<Descriptions layout="horizontal" column={{ xs: 1, md: 2 }} className="my-2" size="small">
								<Descriptions.Item label="From">{StateToTextMap[log.fromState]}</Descriptions.Item>
								<Descriptions.Item label="From">{StateToTextMap[log.toState]}</Descriptions.Item>
								<Descriptions.Item label="By">{`${log.actor.profile.firstName} ${log.actor.profile.lastName} (${log.actor.email})`}</Descriptions.Item>
							</Descriptions>
						</Timeline.Item>
					))}
				</Timeline>
			</div>
		</Modal>
	);
}
